import { forwardRef } from 'react'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useRouteModeAnchor } from '../useRouteModeAnchor.js'

import { AnchorComponentProps } from './index.js'

const DesignLink = forwardRef<HTMLAnchorElement, AnchorComponentProps>(
  (props, ref) => {
    const { Link } = useRouter()
    return <Link ref={ref} href={adminRoutes.design.root} {...props} />
  },
)
DesignLink.displayName = 'DesignLink'

export function DesignModeDropDownItem() {
  const anchor = useRouteModeAnchor()
  const Comp = anchor.design ?? DesignLink
  return (
    <Dropdown.Item as={Comp} leadingIcon={<SvgIcon name="drawing-compass" />}>
      <T id="Generics.DesignStudio" defaultMessage="Design Studio" />
    </Dropdown.Item>
  )
}

export function DesignModeSheetItem() {
  const anchor = useRouteModeAnchor()
  const Comp = anchor.design ?? DesignLink
  return (
    <Comp disabled className="flex items-center justify-between p-3">
      <div className="flex items-center gap-2">
        <SvgIcon name="drawing-compass" />
        <T id="Generics.DesignStudio" defaultMessage="Design Studio" />
      </div>
      <T id="Generics.DesktopOnly" defaultMessage="Desktop only" />
    </Comp>
  )
}
